<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <div class="col-sm-6 float-left">
                <h1 class="page-title">
                    <span *ngIf="!ComplaintId">Add IPD Complaint</span>
                    <span *ngIf="ComplaintId">Update IPD Complaint</span>
                </h1>
            </div>
        </div>
        <div class="card">
            <form [formGroup]="userInformation">
                <div class="card-body patientDetailbox">
                    <div class="container-fluid p-3">
                        <h3><strong>Patient Information</strong></h3>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label class="form-label">Patient Name</label>
                                        <input class="form-control readonly" formControlName="pname"
                                            placeholder="Patient Name" readonly />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label class="form-label">Treatment</label>
                                        <input class="form-control readonly" formControlName="treatment"
                                            placeholder="Treatment" readonly />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label class="form-label">Doctor Name</label>
                                        <input class="form-control readonly" formControlName="docname"
                                            placeholder="Doctor Name" readonly />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label class="form-label">Hospital Name</label>
                                        <input class="form-control readonly" formControlName="hospitalname"
                                            placeholder="Hospital Name" readonly />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label class="form-label">Lead Owner Name</label>
                                        <input class="form-control readonly" formControlName="bd_name"
                                            placeholder="Lead Owner Name" readonly />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div style="border: 0.5px solid #f2f2f2;"></div>
            <div class="card-body">
                <form [formGroup]="complaintForm" (submit)="addComplaint()">
                    <div class="container-fluid p-3">
                        <div class="form-group">
                            <h1 class="page-title">Complaint Form</h1>
                            <div class="row">

                                <div class="col-md-6 mt-2">

                                    <label class="form-label">BD (Medical Coordinator)</label>
                                    <mat-select formControlName="bd_com" placeholder="BD (Medical Coordinator)"
                                        multiple>
                                        <mat-option value="{{bd.id}}" *ngFor="let bd of bdComplaintList">
                                            {{bd.option_name}}</mat-option>
                                    </mat-select>

                                </div>

                                <div class="col-md-6 mt-2">
                                    <label class="form-label">Doctor</label>
                                    <mat-select formControlName="doctor_com" placeholder="Doctor" multiple>
                                        <mat-option value="{{doctor.id}}" *ngFor="let doctor of doctorComplaintList">
                                            {{doctor.option_name}}</mat-option>
                                    </mat-select>
                                </div>

                                <div class="col-md-6 mt-2">
                                    <label class="form-label">Hospital Infrastructure</label>
                                    <mat-select formControlName="hospital_infrastructure_com"
                                        placeholder="Hospital Infrastructure" multiple>
                                        <mat-option value="{{hInfrastructure.id}}"
                                            *ngFor="let hInfrastructure of hInfrastructureComplaintList">
                                            {{hInfrastructure.option_name}}</mat-option>
                                    </mat-select>
                                </div>

                                <div class="col-md-6 mt-2">
                                    <label class="form-label">Hospital Staff</label>
                                    <mat-select formControlName="hospital_staff_com" placeholder="Hospital Staff"
                                        multiple>
                                        <mat-option value="{{hStaff.id}}" *ngFor="let hStaff of hStaffComplaintList">
                                            {{hStaff.option_name}}</mat-option>
                                    </mat-select>
                                </div>

                                <div class="col-md-6 mt-2">
                                    <label class="form-label">Admission</label>
                                    <mat-select formControlName="admission_com" placeholder="Admission" multiple>
                                        <mat-option value="{{admission.id}}"
                                            *ngFor="let admission of admissionComplaintList">{{admission.option_name}}
                                        </mat-option>
                                    </mat-select>
                                </div>

                                <div class="col-md-6 mt-2">
                                    <label class="form-label">Discharge</label>
                                    <mat-select formControlName="discharge_com" placeholder="Discharge" multiple>
                                        <mat-option value="{{discharge.id}}"
                                            *ngFor="let discharge of dischargeComplaintList">{{discharge.option_name}}
                                        </mat-option>
                                    </mat-select>
                                </div>

                                <div class="col-md-6 mt-2">
                                    <label class="form-label">Others</label>
                                    <mat-select formControlName="others_com" placeholder="Others" multiple>
                                        <mat-option value="{{other.id}}" *ngFor="let other of otherComplaintList">
                                            {{other.option_name}}</mat-option>
                                    </mat-select>
                                </div>

                                <div class="col-sm-6 mt-2">
                                    <div class="form-group">
                                        <label class="form-label">Complaint Description</label>
                                        <textarea class="form-control" formControlName="complaint_description"></textarea>
                                    </div>
                                </div>

                                <div style='display:none;' class="col-md-6 mt-2">

                                    <div class="form-group" >
                                        <label class="form-label">Upload Hospital Infrastructure Complaint Document</label>
                                        <input type="file" class="form-control" (change)="selectAadhar($event)" />
                                    </div>
                            
                                    <div *ngIf="showDocs" class="list-group list-group-flush list-group-hoverable">
                                            <div class="row align-items-center">
                                                <div class="col text-truncate">
                                                    <a *ngIf="hospital_infrastructure_comp_doc != null " href="{{s3url}}{{hospital_infrastructure_comp_doc}}" target="_blank" class="text-body d-block">View File</a>
                                                    <small class="d-block text-muted text-truncate mt-n1">{{hospital_infrastructure_comp_doc}}</small>
                                                </div>
                                            </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                    <div class="card-footer">
                        <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                                class="fa fa-spin fa-spinner"></i>
                            <span *ngIf="ComplaintId">Update Complaint</span>
                            <span *ngIf="!ComplaintId">Add Complaint</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>